<template>
  <div class="hot_div">
    <div class="hot_list">
      <div class="flex_between div_title">
        <div style="display:flex">
          <h4
            @click="chageid(1)"
            :class="{title:true,titleactive:activeti===1}"
            style="margin-right:30px"
          >文章收藏</h4>
          <h4
            @click="chageid(2)"
            :class="{title:true,titleactive:activeti===2}"
          >视频收藏</h4>
        </div>
        <div class="flex_center title_right">
          <!-- delvedio -->
          <span
            class="del"
            @click="del"
            v-if="activeti===1&&state"
          >取消收藏</span>
          <span
            class="del"
            @click="delvedio"
            v-if="activeti===2&&state"
          >取消收藏</span>
          <button
            class="flex_center"
            @click="state = !state"
            :class="{'state':state}"
          >
            <span v-if="!state">管理</span>
            <span v-else>取消</span>
          </button>
        </div>
      </div>
      <div
        class="list_ul recommended_list"
        v-if="activeti===1&&list_ul.length>0"
      >
        <div
          class="recommended_li flex_between"
          @click="detailsFun(index)"
          v-for="(liem,index) in list_ul"
          :key="index"
        >
          <i
            class="gou_icon"
            v-if="state"
            @click.stop='liem.is_selected = !liem.is_selected'
          >
            <img
              v-if="!liem.is_selected"
              src="@/assets/img/gou.png"
              alt=""
            >
            <img
              v-else
              src="@/assets/img/gouT.png"
              alt=""
            >
          </i>
          <!-- <div class="list_left flex_between">
                        <h3 class="list_title clamp1">
                            <span class="list_tag" v-for="lise in liem.lable"
                                :style="{'color':lise.color,'border-color':lise.color}">{{lise.title}}</span>
                            {{liem.title}}
                        </h3>
                        <div class="list_describe clamp2" v-html="liem.content">
                        </div>
                        <div class="list_time flex_start">
                            <span class="original">原创:{{liem.user}}</span>
                            <span class="time">{{liem.create_time}}</span>
                            <div class="flex_center operation">
                                <div class="flex_center operation_li">
                                    <i><img src="@/assets/img/liulanP.png" alt=""></i>
                                    {{liem.see}}
                                </div>
                                <div class="flex_center operation_li">
                                    <i><img src="@/assets/img/dianzhanP.png" alt=""></i>
                                    {{liem.goods}}
                                </div>
                                <div class="flex_center operation_li">
                                    <i><img src="@/assets/img/pinglunP.png" alt=""></i>
                                    {{liem.comment}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <i class="flex_center list_right contain_img">
                        <img v-if="liem.cover[0]" :src="liem.cover[0]" alt="">
                        <img v-else src="@/assets/img/bg.jpg" alt="">
                    </i> -->
          <!-- 左边摘要 -->
          <div
            class="flex_between left_text text_div div_zuoyou"
            v-if="liem.summary_location == 3"
          >
            <h3 class="list_title clamp1">
              <span
                class="list_tag"
                v-for="lise in liem.lable"
                :style="{'color':lise.color,'border-color':lise.color}"
              >{{lise.title}}</span>
              {{liem.title}}
            </h3>
            <div class="list_left flex_between">

              <div class="original clamp1 flex_center"><span>原创：{{liem.user}}</span> <span class="time clamp1">{{liem.create_time}}</span></div>
              <div
                class="list_describe clamp3"
                v-html="liem.content"
              >
              </div>
              <div class="list_time flex_between">
                <div class="flex_center operation">
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/liulanP.png"
                        alt=""
                      ></i>
                    {{liem.see}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/dianzhanP.png"
                        alt=""
                      ></i>
                    {{liem.goods}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/pinglunP.png"
                        alt=""
                      ></i>
                    {{liem.comment}}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="list_right flex_center"
              v-if="liem.cover_video"
              @click.stop=""
            >
              <i class="contain_video">
                <video
                  controlslist='nodownload'
                  oncontextmenu="return false"
                  ref="video"
                  :src="liem.cover_video"
                  preload
                  controls
                  :poster="liem.video_image?liem.video_image:'@/assets/img/app_logo.png'"
                ></video>
              </i>
            </div>
            <div
              class="list_right flex_center"
              v-else
            >
              <i
                class="contain_img"
                v-for="(liemT,indexT) in liem.cover"
                v-if="indexT<3"
              >
                <img
                  v-if="liemT"
                  :src="liemT"
                  alt=""
                >
                <img
                  v-else
                  src="@/assets/img/app_logo.png"
                  alt=""
                >
              </i>
            </div>
          </div>
          <!-- 右边摘要 -->
          <div
            class="flex_between rigth_text left_text text_div div_zuoyou"
            v-if="liem.summary_location == 4"
          >
            <h3 class="list_title clamp1">
              <span
                class="list_tag"
                v-for="lise in liem.lable"
                :style="{'color':lise.color,'border-color':lise.color}"
              >{{lise.title}}</span>
              {{liem.title}}
            </h3>
            <div
              class="list_right flex_center"
              v-if="liem.cover_video"
              @click.stop=""
            >
              <i class="contain_video">
                <video
                  controlslist='nodownload'
                  oncontextmenu="return false"
                  ref="video"
                  :src="liem.cover_video"
                  preload
                  controls
                  :poster="liem.video_image?liem.video_image:'@/assets/img/app_logo.png'"
                ></video>
              </i>
            </div>
            <div
              class="list_right flex_center"
              v-else
            >
              <i
                class="contain_img"
                v-for="(liemT,indexT) in liem.cover"
                v-if="indexT<3"
              >
                <img
                  v-if="liemT"
                  :src="liemT"
                  alt=""
                >
                <img
                  v-else
                  src="@/assets/img/app_logo.png"
                  alt=""
                >
              </i>
            </div>
            <div class="list_left flex_between">

              <div class="original clamp1 flex_center"><span>原创：{{liem.user}}</span> <span class="time clamp1">{{liem.create_time}}</span></div>
              <div
                class="list_describe clamp3"
                v-html="liem.content"
              >
              </div>
              <div class="list_time flex_between">

                <div class="flex_center operation">
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/liulanP.png"
                        alt=""
                      ></i>
                    {{liem.see}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/dianzhanP.png"
                        alt=""
                      ></i>
                    {{liem.goods}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/pinglunP.png"
                        alt=""
                      ></i>
                    {{liem.comment}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 上边摘要 -->
          <div
            class="flex_between top_text left_text text_div"
            v-if="liem.summary_location == 1"
          >

            <div class="list_left flex_between">
              <h3 class="list_title clamp1">
                <span
                  class="list_tag"
                  v-for="lise in liem.lable"
                  :style="{'color':lise.color,'border-color':lise.color}"
                >{{lise.title}}</span>
                {{liem.title}}
              </h3>
              <div class="original clamp1">原创：{{liem.user}}</div>
              <div
                class="list_describe clamp2"
                v-html="liem.content"
              >
              </div>
              <div
                class="list_right flex_center"
                v-if="liem.cover_video"
                @click.stop=""
              >
                <i class="contain_video">
                  <video
                    controlslist='nodownload'
                    oncontextmenu="return false"
                    ref="video"
                    :src="liem.cover_video"
                    @click.stop="Videostate"
                    preload
                    controls
                    :poster="liem.video_image?liem.video_image:'@/assets/img/app_logo.png'"
                  ></video>
                </i>
              </div>
              <div
                class="list_right flex_start"
                v-else
              >
                <i
                  class="contain_img"
                  :class="{'max' : liem.cover.length == 1}"
                  v-for="(liemT,indexT) in liem.cover"
                  v-if="indexT<4"
                >
                  <img
                    v-if="liemT"
                    :src="liemT"
                    alt=""
                  >
                  <img
                    v-else
                    src="@/assets/img/app_logo.png"
                    alt=""
                  >
                </i>
              </div>
              <div class="list_time flex_between">

                <span class="time clamp1">{{liem.create_time}}</span>
                <div class="flex_center operation">
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/liulanP.png"
                        alt=""
                      ></i>
                    {{liem.see}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/dianzhanP.png"
                        alt=""
                      ></i>
                    {{liem.goods}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/pinglunP.png"
                        alt=""
                      ></i>
                    {{liem.comment}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 下边摘要 -->
          <div
            class="flex_between top_text bottom_text left_text text_div"
            v-if="liem.summary_location == 2"
          >

            <div class="list_left flex_between">
              <h3 class="list_title clamp1">
                <span
                  class="list_tag"
                  v-for="lise in liem.lable"
                  :style="{'color':lise.color,'border-color':lise.color}"
                >{{lise.title}}</span>
                {{liem.title}}
              </h3>
              <div class="original clamp1">原创：{{liem.user}}</div>
              <div
                class="list_right flex_center"
                v-if="liem.cover_video"
                @click.stop=""
              >
                <i class="contain_video">
                  <video
                    controlslist='nodownload'
                    oncontextmenu="return false"
                    ref="video"
                    :src="liem.cover_video"
                    preload
                    controls
                    :poster="liem.video_image?liem.video_image:'@/assets/img/app_logo.png'"
                  ></video>
                </i>
              </div>
              <div
                class="list_right flex_start"
                v-else
              >
                <i
                  class="contain_img"
                  :class="{'max' : liem.cover.length == 1}"
                  v-for="(liemT,indexT) in liem.cover"
                  v-if="indexT<4"
                >
                  <img
                    v-if="liemT"
                    :src="liemT"
                    alt=""
                  >
                  <img
                    v-else
                    src="@/assets/img/app_logo.png"
                    alt=""
                  >
                </i>
              </div>
              <div
                class="list_describe clamp2"
                v-html="liem.content"
              >
              </div>

              <div class="list_time flex_between">

                <span class="time clamp1">{{liem.create_time}}</span>
                <div class="flex_center operation">
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/liulanP.png"
                        alt=""
                      ></i>
                    {{liem.see}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/dianzhanP.png"
                        alt=""
                      ></i>
                    {{liem.goods}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/pinglunP.png"
                        alt=""
                      ></i>
                    {{liem.comment}}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div
        class="list_ul recommended_list"
        v-if="activeti===2&&list_ul.length>0"
      >
        <div
          class="list_li flex_center"
          :class="{'selsected':liem.is_selected&&state}"
          @click.stop="detailsFunvedio(index)"
          v-for="(liem,index) in list_ul"
          :key="liem.id"
        >
          <i
            class="gou_icon"
            v-if="state"
          >
            <img
              v-if="!liem.is_selected"
              src="@/assets/img/gou.png"
              alt=""
            >
            <img
              v-else
              src="@/assets/img/gouT.png"
              alt=""
            >
          </i>
          <i class="li_icon">
            <img
              v-if="liem.cover"
              :src="liem.cover"
              alt=""
            >
            <img
              v-else
              src="@/assets/img/app_logo.png"
              alt=""
            >
          </i>
          <h4>{{liem.title}}</h4>
        </div>

      </div>
    </div>
    <div
      class="flex_center no_center"
      v-if="list_ul.length===0"
    >
    <!-- recommended_icon -->
      <i v-if="is_loading"><img
          src="@/assets/img/kkry_pc.gif"
          alt=""
        ></i>
      <div
        class="flex_center prompt_text"
        v-if="is_loading"
      >
        暂无收藏，前往推荐看看吧! <a
          v-if="activeti===1"
          href="javaScript:void(0)"
          @click.stop="geHome(1)"
        >推荐</a>
        <a
          v-if="activeti===2"
          href="javaScript:void(0)"
          @click.stop="geHome(2)"
        >推荐</a>
      </div>
      <div
        v-else
        class="flex_center prompt_text"
      >
        加载中...
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'popup',
  data () {
    return {
      state: false,//管理状态
      user: {},//用户信息
      list_ul: [],
      page: 1,
      is_loading: false,
      activeti: 1,
    }
  },
  props: {

  },
  watch: {

  },
  methods: {
    chageid (id) {
      this.activeti = id
      this.getList()
    },
    del () {//删除关注
      let that = this;
      let arr = [];
       
      this.list_ul.forEach((liem, index) => {
        if (liem.is_selected) {
          arr.push(liem.news_id)
        }
      })
      if (arr.length > 0) {
        layer.open({
          content: '您确认取消这些收藏吗？'
          , style: 'background-color:#fef0f0; color:#F56C6C;font-size:18px; border:none;' //自定风格
          , btn: ['确定', '取消']
          , yes: function (index) {
            layer.close(index);
            that.$post('collect', {
              news_id: arr.join(","),
              member_id: that.USER().id,
              type: 2,
            }).then(res => {
              layer.open({
                content: "取消收藏成功",
                time: true,
                skin: "msg"
              });
              that.state = false;
              that.page = 1;
              that.getList();
              that.$parent.beiChildMethod();
            })
          }
        })
      }

    },
    delvedio () {
      let that = this;
      let arr = [];
       
      this.list_ul.forEach((liem, index) => {
        if (liem.is_selected) {
          arr.push(liem.video_id)
        }
      })
      if (arr.length > 0) {
        layer.open({
          content: '您确认取消这些收藏吗？'
          , style: 'background-color:#fef0f0; color:#F56C6C;font-size:18px; border:none;' //自定风格
          , btn: ['确定', '取消']
          , yes: function (index) {
            layer.close(index);
            that.$post('collect', {
              video_id: arr.join(","),
              member_id: that.USER().id,
              type: 2,
            }).then(res => {
              layer.open({
                content: "取消收藏成功",
                time: true,
                skin: "msg"
              });
              that.state = false;
              that.page = 1;
              that.getList();
              that.$parent.beiChildMethod();
            })
          }
        })
      }

    },
    detailsFun (index) {//查看详情
      if (this.state) {
        this.list_ul[index].is_selected = !this.list_ul[index].is_selected;
      } else {
        this.$router.push({ path: '/column_details', query: { id: this.list_ul[index].news_id, head_index: 2 } });
      }
    },
    detailsFunvedio (index) {
      if (this.state) {
        this.list_ul[index].is_selected = !this.list_ul[index].is_selected;
      } else {
        this.$router.push({ path: '/vedio_detil', query: { id: this.list_ul[index].video_id, configid: this.list_ul[index].video_conf_id } });
      }

    },
    geHome: function (id) {
      if (id === 1) {
        this.$router.replace('/column');
      } else {
        this.$router.replace('/vedio');
      }
    },

    getList () {
      let that = this;
      if (this.page == 1) {
        this.list_ul = [];
      }
      this.$post('follow_comment', {
        type: 3,//1评论2关注3收藏
        member_id: this.USER().id,
      }).then(res => {
        that.is_loading = true;
        if (this.activeti === 1) {
          if (res.data) {
            res.data.news.forEach((element, index) => {
              res.data.news[index].is_selected = false;
            });
          }
          that.list_ul = res.data.news;
        } else {
          if (res.data) {
            res.data.video.forEach((element, index) => {
              res.data.video[index].is_selected = false;
            });
          }
          that.list_ul = res.data.video;
        }

        that.$nextTick(() => {
          that.videoFun();
        })
      })
    },
    getUser () {
      let that = this;
      this.REFRESH_USER();
      that.user = this.USER();
      this.getList();
    },
    videoFun () {
       
      var au = document.getElementsByTagName("video");
      for (var i = 0; i < au.length; i++) {
        au[i].addEventListener("playing", function () {
          var this1 = this;
          this.play();
          for (var b = 0; b < au.length; b++) {
            var this2 = au[b];
            if (this1 !== this2) {
              this2.pause();
            }
          }
        });
      }
    },
  },
  mounted () {
    this.getUser();

    let that = this;
    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var scrollHeight = $(document).height();
      var windowHeight = $(this).height();

    });
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div_title {
  height: 48px;
  border-bottom: 1px solid #dfdfdf;
  margin-bottom: 10px;
}

.div_title .title {
  font-size: 18px;
  color: #1a1a1a;
  margin-bottom: 20px;
}

.div_title .title_right > button {
  height: 36px;
  border-radius: 4px;
  background: #db414e;
  color: #fff;
  font-size: 18px;
  border: 0;
  margin-left: 50px;
  width: 88px;
}

.div_title .title_right > button.state {
  color: #1a1a1a;
  background: #dfdfdf;
}
.titleactive {
  color: #db414e !important;
}
.div_title .title_right .del {
  font-size: 18px;
  color: #f24d5b;
  cursor: pointer;
}

.recommended_list {
}
.list_ul {
  padding: 17px 0;
  width: calc(100% + 18px);
  flex-wrap: wrap;
}
.list_ul > div {
  box-sizing: border-box;
}
.list_ul .list_li {
  width: calc(33% - 10px);
  height: 263px;
  border: 1px solid #999999;
  position: relative;
  flex-direction: column;
  display: inline-flex;
  border-radius: 10px;
  margin: 0 10px 10px 0;
  background: #fff;
  cursor: pointer;
  transition: all 0.5s ease;
}

.list_ul .list_li:hover {
  background: rgba(255, 114, 89, 0.4);
  border-color: #f24d5b;
}

.list_ul .list_li.selsected {
  border-color: #f24d5b;
}

.list_ul .list_li .gou_icon {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 28px;
  height: 28px;
}

.list_ul .list_li .li_icon {
  width: 80%;
  height: 110px;
  margin-bottom: 30px;
  overflow: hidden;
}
.li_icon > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.list_ul .list_li > h4 {
  font-size: 16px;
  color: #f5ab16;
  width: 80%;
  height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 0 auto;
}

.no_center {
  flex-direction: column;
  padding-top: 72px;
}

.no_center > i {
  width: 300px;
  margin-bottom: 40px;
}

.no_center .prompt_text {
  font-size: 18px;
  color: #666;
}

.no_center .prompt_text > a {
  color: #f24d5b;
  margin-left: 10px;
}
.recommended_list .recommended_li {
  padding: 30px 25px 30px 50px;
  border-bottom: 1px solid #dfdfdf;
  height: 152px;
  cursor: pointer;
  transition: all 0.5s ease;
  position: relative;
}

.recommended_list .recommended_li .gou_icon {
  width: 24px;
  height: 24px;
}

.recommended_li .list_left {
  flex: 1;
  margin-right: 15px;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
}

.list_left .list_title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  align-items: flex-start;
  line-height: 1.1em;
}

.list_left .list_title > .list_tag {
  border-radius: 4px;
  border: 2px solid #9749bb;
  color: #9749bb;
  font-size: 14px;
  margin-right: 10px;
  padding: 0 10px;
  line-height: 24px;
  height: 24px;
}

.recommended_li .list_describe {
  font-size: 14px;
  color: #666;
}

.recommended_li .list_time .original {
  font-size: 14px;
  color: #333;
  margin-right: 12px;
}

.recommended_li .list_time .time {
  font-size: 14px;
  color: #999;
  margin-right: 54px;
}

.recommended_li .list_time .operation .operation_li {
  font-size: 14px;
  color: #999;
  margin-right: 24px;
}

.recommended_li .list_time .operation .operation_li > i {
  width: 15px;
  margin-right: 4px;
}

.recommended_li .list_right {
  width: 160px;
  border-radius: 4px;
  overflow: hidden;
  height: 100%;
}

.recommended_li .list_right img {
  transition: all 0.5s ease;
  object-fit: cover;
  height: 100%;
}

.recommended_list .recommended_li:hover {
  /* background: #f4f4f4; */
}

.recommended_list .recommended_li:hover .list_right > img {
  transform: scale(1.2);
}

.recommended_list .recommended_li .gou_icon {
  position: absolute;
  top: 30px;
  left: -12px;
}

/* 暂无数据 */
.no_center {
  flex-direction: column;
  padding-top: 72px;
}

.no_center > i {
  width: 300px;
  margin-bottom: 40px;
}

.no_center .prompt_text {
  font-size: 18px;
  color: #666;
}

.no_center .prompt_text > a {
  color: #f24d5b;
  margin-left: 10px;
}

.recommended_list {
}

.recommended_list .recommended_li {
  padding: 30px 10px 30px 25px;
  border-radius: 4px;
  border-bottom: 1px solid #dfdfdf;
  height: auto;
  cursor: pointer;
  transition: all 0.5s ease;
}

.recommended_list .recommended_li .text_div {
  width: 100%;
  height: 100%;
}

.recommended_li .list_left {
  flex: 1;
  margin-right: 15px;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
}

.text_div .list_title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  align-items: flex-start;
  line-height: 1.1em;
  width: 100%;
}

.text_div .list_title > .list_tag {
  border-radius: 4px;
  border: 2px solid #9749bb;
  color: #9749bb;
  font-size: 14px;
  margin-right: 10px;
  position: relative;
  top: -1px;
  padding: 0 10px;
  line-height: 24px;
  height: 24px;
}

.recommended_li .list_describe {
  font-size: 14px;
  color: #666;
}

.recommended_li .list_time {
  width: 100%;
  margin-top: 10px;
}

.recommended_li .original {
  font-size: 15px;
  color: #333;
  margin: 10px 0;
}

.recommended_li .list_time .time {
  font-size: 14px;
  color: #999;
}

.recommended_li .list_time .operation .operation_li {
  font-size: 14px;
  color: #999;
  margin-right: 24px;
}

.recommended_li .list_time .operation .operation_li > i {
  width: 15px;
  margin-right: 4px;
}

.recommended_li .list_right {
  height: 100%;
  overflow: hidden;
}
.recommended_list .recommended_li .list_right {
  width: auto;
}
.recommended_li .list_right .contain_img {
  margin-left: 10px;
  width: 140px;
  border-radius: 4px;
  overflow: hidden;
  height: 130px;
  background: transparent;
}

.recommended_li .list_right .contain_img > img {
  transition: all 0.5s ease;
  object-fit: cover;
}

.recommended_list .recommended_li:hover {
  /* background: #f4f4f4; */
}

.recommended_list .recommended_li:hover .list_right > .contain_img img {
  transform: scale(1.2);
}

.recommended_list .recommended_li .list_right .contain_video {
  width: 100%;
}

.recommended_list .recommended_li .list_right .contain_video > video {
  width: 100%;
}

/* 载要左边 */
.recommended_list .recommended_li .left_text {
  min-height: 160px;
  flex-wrap: wrap;
}
.recommended_list .recommended_li .left_text .list_describe {
  height: 60px;
}
.recommended_list .recommended_li .left_text .original .time {
  font-size: 14px;
  color: #999;
  margin-left: 10px;
}
.recommended_list .recommended_li .left_text.div_zuoyou .list_title {
  margin-bottom: 20px;
}

.recommended_list .recommended_li .left_text.div_zuoyou .list_right {
  height: 140px;
}

.recommended_list .recommended_li .left_text.div_zuoyou .list_left {
  height: 140px;
}

.recommended_list
  .recommended_li
  .left_text.div_zuoyou
  .list_right
  .contain_video {
  width: 250px;
  margin-right: 10px;
}

/* 右边摘要  */
.recommended_list .recommended_li .left_text.rigth_text .contain_img {
  margin: 0 10px 0 0;
}

/* 上边摘要 */

.recommended_list .recommended_li .left_text.top_text {
  flex-direction: column;
  width: 100%;
  height: auto;
}
.recommended_list .recommended_li .left_text.top_text .list_describe {
  height: auto;
  margin-top: 10px;
}
.recommended_list .recommended_li .left_text.top_text .list_left {
  width: 100%;
}

.recommended_list .recommended_li .left_text.top_text .list_right {
  white-space: wrap;
  flex-wrap: wrap;
  width: 100%;
}

.recommended_list .recommended_li .left_text.top_text .list_right .contain_img {
  margin: 10px 10px 10px 0;
}

.recommended_list .recommended_li .left_text.top_text .list_right .contain_img {
  margin: 10px 10px 10px 0;
}
.recommended_list .recommended_li .left_text.top_text .contain_img.max {
  width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/pc_viwe/my_collection.vue